import http, { HTTPResultAsync } from '@/utils/http';
import { contentVariables } from '@/constants';

const { CONTENT_PROVIDER_URL, STRAPI_TOKEN } = contentVariables;

const contentMap = {
  prelogin: '/api/my-countly-pre-login?populate%5Bbrands%5D%5Bpopulate%5D=*',
  resources: '/api/my-countly-resources?populate=*',
  features: '/api/my-countly-features?populate=*',
  welcome: '/api/my-countly-welcome-popup?populate=*',
  coreFeatures: '/api/my-countly-core-features',
  pluginFeatures: '/api/my-countly-features',
  announcement: '/api/dashboard-announcement',
};

export enum contentType {
  prelogin = 'prelogin',
  resources = 'resources',
  features = 'features',
  welcome = 'welcome',
  coreFeatures = 'coreFeatures',
  pluginFeatures = 'pluginFeatures',
  announcement = 'announcement',
}

export async function getContent(type: contentType): HTTPResultAsync {
  return http.getSafe(`${CONTENT_PROVIDER_URL}${contentMap[type]}`, { Authorization: `bearer ${STRAPI_TOKEN}` });
}
